import { useCallback } from 'react';
import { populateFormFields, validateFormCreation, handleFormSubmission } from '../utils';
import type { IUseCreateFormProps } from '../types';

export const useCreateForm = ({ formId, elementId, redirectUrl, onFormError }: IUseCreateFormProps) => {
  const createForm = useCallback(() => {
    if (!validateFormCreation(elementId, onFormError)) {
      return;
    }

    try {
      window.hbspt?.forms?.create({
        portalId: process.env.GATSBY_HUBSPOT_TRACKING_ID || '',
        formId: formId,
        region: 'na1',
        target: `#${elementId}`,
        // @ts-ignore - onFormReady is part of the hubspot create function
        onFormReady: (form) => populateFormFields(form),
        onFormSubmitted: () => handleFormSubmission(redirectUrl),
        onFormError: function (error: unknown) {
          console.error('Form creation error:', error);
          onFormError();
        },
      });
    } catch (error) {
      console.error('Error creating form:', error);
      onFormError();
    }
  }, [formId, elementId, redirectUrl, onFormError]);

  return { createForm };
}; 
